export default __webpack_public_path__ + "static/go-karting-driver-f9c9d172515a90405724929144706b14.jpg";